var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabGroupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81836 1H106.182C108.843 1 111 3.15735 111 5.81836V74.1816C111 76.8426 108.843 79 106.182 79H5.81836C3.15735 79 1 76.8427 1 74.1816V5.81836C1 3.15735 3.15735 1 5.81836 1Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81836 1H106.182C108.843 1 111 3.15735 111 5.81836V74.1816C111 76.8426 108.843 79 106.182 79H5.81836C3.15735 79 1 76.8427 1 74.1816V5.81836C1 3.15735 3.15735 1 5.81836 1Z",
    stroke: "#fff",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 94,
    height: 14,
    rx: 1.90909,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 94,
    height: 14,
    rx: 1.90909,
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16H96",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5715,
    y: 32,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#FFB279"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1428,
    y: 31,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#D98DFA",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.7144,
    y: 32,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#CCEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.2856,
    y: 32,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#0079D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.8572,
    y: 32,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#DCD2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4285,
    y: 32,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#FF8A50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 32,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#754FE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 49,
    width: 94,
    height: 22,
    rx: 1.90909,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 49,
    width: 94,
    height: 22,
    rx: 1.90909,
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0831 54.8629 51.2196 54.2261C51.2841 53.9246 51.7146 53.9246 51.7799 54.2261L51.9164 54.8629C51.9404 54.9731 52.0259 55.0594 52.1361 55.0826L52.7729 55.2191C53.0744 55.2836 53.0744 55.7141 52.7729 55.7794L52.1369 55.9166C52.0266 55.9399 51.9404 56.0261 51.9171 56.1364L51.7799 56.7731C51.7154 57.0746 51.2849 57.0746 51.2196 56.7731L51.0831 56.1364C51.0599 56.0261 50.9736 55.9399 50.8634 55.9166L50.2266 55.7794C49.9251 55.7149 49.9251 55.2844 50.2266 55.2191L50.8634 55.0826C50.9736 55.0594 51.0599 54.9731 51.0831 54.8629ZM51.0831 63.8629 51.2196 63.2261C51.2841 62.9246 51.7146 62.9246 51.7799 63.2261L51.9164 63.8629C51.9404 63.9731 52.0259 64.0594 52.1361 64.0826L52.7729 64.2191C53.0744 64.2836 53.0744 64.7141 52.7729 64.7794L52.1361 64.9159C52.0259 64.9399 51.9396 65.0254 51.9164 65.1356L51.7799 65.7724C51.7154 66.0739 51.2849 66.0739 51.2196 65.7724L51.0831 65.1356C51.0591 65.0254 50.9736 64.9391 50.8634 64.9159L50.2266 64.7794C49.9251 64.7149 49.9251 64.2844 50.2266 64.2191L50.8634 64.0826C50.9736 64.0594 51.0599 63.9731 51.0831 63.8629Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6978 55.3943C57.3582 54.5343 56.1421 54.5343 55.8025 55.3943L54.8604 57.7838C54.8014 57.933 54.6833 58.051 54.534 58.1101L52.1448 59.052C51.2848 59.3916 51.2851 60.6078 52.1451 60.9474L54.5344 61.8894C54.6835 61.9485 54.8015 62.0666 54.8605 62.2157L55.8025 64.605C56.1421 65.465 57.3583 65.4647 57.6979 64.6047L58.6399 62.2154C58.6989 62.0663 58.8171 61.9483 58.9662 61.8892L61.3555 60.9473C62.2155 60.6077 62.2152 59.3915 61.3552 59.0518L58.966 58.11C58.8168 58.0509 58.6988 57.9327 58.6397 57.7836L57.6978 55.3943ZM55.9069 58.1967L56.7501 56.0578L57.5935 58.1972C57.767 58.6358 58.1145 58.983 58.5531 59.1564L60.692 59.9996L58.5525 60.8431C58.1139 61.0165 57.7668 61.364 57.5933 61.8026L56.7501 63.9415L55.9067 61.8021C55.7333 61.3635 55.3858 61.0163 54.9472 60.8428L52.8083 59.9996L54.9477 59.1562C55.3863 58.9828 55.7335 58.6353 55.9069 58.1967Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0H96V64H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabGroupIcon);
export default __webpack_public_path__ + "static/media/tab-group-icon.0559aa7f4ed0ea5d1d235cf62e047531.svg";
export { ForwardRef as ReactComponent };